import React from 'react';

// Company logo map — add base64 data URIs here when PNG files are available
export const companyLogos = {
  'XMEK': null, // Will use SVG fallback
};

// SVG fallback for companies without a PNG logo
export const CompanyLogoFallback = ({ name, width = 100, height = 40 }) => {
  const logos = {
    'XMEK': (
      <svg width={width} height={height} viewBox="0 0 100 40">
        <rect width="100" height="40" rx="6" fill="#0F172A"/>
        <text x="50" y="27" textAnchor="middle" fill="#3B82F6" fontFamily="'Inter',Helvetica,Arial,sans-serif" fontWeight="bold" fontSize="20" letterSpacing="2">XMEK</text>
      </svg>
    ),
  };
  return logos[name] || null;
};

// Render a company logo — returns img tag if base64 exists, SVG fallback otherwise, null if no logo defined
export const CompanyLogo = ({ name, width = 100, height = 40, style = {} }) => {
  const base64 = companyLogos[name];
  if (base64) {
    return <img src={base64} alt={name} style={{ width, height, objectFit: 'contain', ...style }} />;
  }
  if (companyLogos.hasOwnProperty(name)) {
    return <CompanyLogoFallback name={name} width={width} height={height} />;
  }
  return null;
};
